import {GET_VACATION_HOUR_LIST,GET_CURRENT_VACATION_HOUR_LIST} from '../actionTypes'
const defaultState = {
    vacationHourList: [],
    currentVacationHrs:[]
  };  
  export default (state = defaultState, action) => {
    switch (action.type) {
      case GET_VACATION_HOUR_LIST:
        return { ...state, vacationHourList: action.payload||defaultState.vacationHourList };
        case GET_CURRENT_VACATION_HOUR_LIST:
        return { ...state, currentVacationHrs: action.payload||defaultState.currentVacationHrs };
      default:
        return state;
    }
  };